import logo1 from "../../assets/img/historicEvents/LogoOnlysPPV/BP.png";

export const breakingPointDetail = {
  "breaking-point": {
    id: "breaking-point",
    title: "Breaking Point",
    subtitle: "Explore the event editions in a dedicated event view.",
    tabs: [
      {
        id: "editions",
        label: "Editions",
        variant: "breaking-point",
        items: [
          {
            id: "breaking-point-1",
            title: "Breaking Point",
            description: "2009",
            imgUrl: logo1,
          },
        ],
      },
    ],
  },
};
